import { useState, useImperativeHandle, forwardRef, useRef, React, useEffect } from 'react';
import styled from 'styled-components';

const SignUpEmailInput = forwardRef((props, ref) => {
	const { className, placeholder, type, clickCountFn, clickFn, text, isClicked, setIsClicked, onEmailChange, isVerified } = props;
	const [value, setValue] = useState('');
	const [changed, setChanged] = useState(false);
	const [message, setMessage] = useState(text);
	const [clickCount, setClickCount] = useState(0);
	const [defaultPlaceholder, setDefaultPlaceholder] = useState(placeholder);

	const BorderRef = useRef();
	const inputRef = useRef();

	const isButtonDisabled = isClicked || isVerified;

	useImperativeHandle(ref, () => ({
		setValue: (val) => {
			setValue(val);
			setChanged(true);
		},
		getValue: () => {
			if (changed)
				return value;
			else
				return "";
		},
		plusClickCount: () => {
			setClickCount(clickCount + 1)
		},
		getClickCount: () => {
			return clickCount;
		},
		setDefaultPlaceholder: (val) => {
		setDefaultPlaceholder(val);

		if (isVerified) return;

		inputRef.current.style.borderColor = '#FF3131';
		BorderRef.current.style.borderBottom = '1px solid #FF3131';
		},
		reset: (val) => {
			setClickCount(0);
			setDefaultPlaceholder(val)
			inputRef.current.style.borderColor = '#E8E8E8';
			BorderRef.current.style.borderBottom = '1px solid #E8E8E8';
		}
	}));

	useEffect(() => {
		const borderEl = BorderRef.current;

		if (!borderEl) return;

		if (isVerified) {
			borderEl.style.borderBottom = '1px solid #E8E8E8'; // 인증완료면 항상 회색

			return;
		}

		if (isClicked) {
			borderEl.style.borderBottom = '1px solid #E8E8E8';
			// borderEl.style.borderBottom = '1px solid #FF8B48';

			return;
		}

		// 기본 상태
		borderEl.style.borderBottom = '1px solid #E8E8E8';
	}, [isVerified, isClicked]);

	useEffect(() => {
		clickCountFn(className, clickCount);
	}, [clickCount, value])

	function handleClick(e) {
		if (!isVerified) {
			inputRef.current.style.borderColor = '#FF8B48';
			BorderRef.current.style.borderBottom = '1px solid #FF8B48';
		}
		setDefaultPlaceholder('');
	}

	function handleChange(e) {
		const next = e.target.value;
		setValue(next);
		setChanged(true);
		onEmailChange && onEmailChange(next);
    	setIsClicked(false);
	}

	function handleFocus(e) {
		// if (changed) {
		// 	// do nothing
		// } else {
		// 	setValue("");
		// }
	}

	function handleBlur() {
		setClickCount(clickCount + 1);
		inputRef.current.style.borderColor = '#E8E8E8';

		if (isVerified) {
		BorderRef.current.style.borderBottom = '1px solid #E8E8E8';
		}
		else {
		BorderRef.current.style.borderBottom = '1px solid #E8E8E8';
		}
	}

	function handleCheckClick(e) {
		e.stopPropagation();

		if (isButtonDisabled) return;
		clickFn && clickFn();
	}

	return (
		<TopLevelWrapper ref={BorderRef}>
			<Input
				ref={inputRef}
				clickCount={clickCount}
				type={type}
				placeholder={defaultPlaceholder}
				value={value}
				className={`${className} ${changed ? "changed" : ""}`}
				onClick={handleClick}
				onChange={handleChange}
				onFocus={handleFocus}
				onBlur={handleBlur} />
				<CheckButton onClick={handleCheckClick} isClicked={isClicked} disabled={isButtonDisabled}>
					{isVerified ? '인증완료' : (isClicked ? '확인중' : '계정확인')}
				</CheckButton>
		</TopLevelWrapper>
	)
});

export default SignUpEmailInput;

const TopLevelWrapper = styled.div`
	display: flex;
	flex-direction: row;

	justify-content: space-between;
	align-items: flex-end;
	
	// border-width: 0 0 1px 0;
	border-bottom: 1px solid #E8E8E8;

  transition: all 0.5s ease-in-out;
	// border-color: #E8E8E8;

	
	// border-width: 0 0 1px 0;
	// border-color: #E8E8E8;
	// border: 0px;
`;

const Input = styled.input`
	font-family: NotoSansKR-Regular;
	font-size: 16px;
	// font-size: max(12px, 0.7291666666666667vw);
	// line-height: 20px;
	
	padding: 0 0 4px 0;
	margin-top: 10px;
	// margin-top: max(12px, 0.8333333333333333vw);

	// width: 80%;
	width: calc(100% - 79px);

	outline: none;
	// border-width: 0 0 1px 0;
	// border-color: #E8E8E8;
	border: 0px;
	color: #000000;

	::placeholder {
		color: ${props => props.clickCount < 1 || props.value !== '' ? `#CBCBCB` : `#FF3131;`};
	}
	
  transition: all 0.5s ease-in-out;
`;

const CheckButton = styled.div`
	display: flex;
	flex-direction: row;

	justify-content: center;
	align-items: center;

	width: 79px;
	height: 32px;

	border-radius: 8px 8px 0 0;
	background-color: ${(props) => props.disabled ? '#E8E8E8' : (props.isClicked ? '#E8E8E8' : '#FF8B48')};

	opacity: ${(props) => (props.disabled ? 0.7 : 1)};
	pointer-events: ${(props) => (props.disabled ? 'none' : 'auto')};

	font-family: NotoSansKR-Bold;
	font-size: max(14px, 0.625vw);

	color: #FFFFFF;

	margin-bottom: -1px;

	&:hover {
    	cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};
	}
`;